<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import EmailSetupPanel from './EmailSetupPanel.vue';

const props = defineProps({
  inbox: {
    type: Object,
    required: true,
  },
  inboxId: {
    type: [String, Number],
    required: true,
  },
});

const { t } = useI18n();

const message = computed(() => {
  return props.inbox.forwarding_enabled
    ? t('INBOX_MGMT.ADD.EMAIL_CHANNEL.FINISH_MESSAGE')
    : t('INBOX_MGMT.ADD.EMAIL_CHANNEL.FINISH_MESSAGE_NO_FORWARDING');
});
</script>

<template>
  <div class="w-full max-w-3xl mx-auto">
    <p
      class="text-base text-n-slate-11 mt-4 mb-6 mx-auto leading-7 text-center"
    >
      {{ message }}
    </p>

    <EmailSetupPanel v-if="inbox.forwarding_enabled" :inbox="inbox" />

    <p class="mt-8 text-sm text-n-slate-11 pb-4 text-center">
      <router-link
        :to="{
          name: 'settings_inbox_show',
          params: { inboxId: inboxId, tab: 'configuration' },
        }"
        class="text-n-woot-600 hover:text-n-woot-700 underline"
      >
        {{ $t('INBOX_MGMT.ADD.EMAIL_CHANNEL.CONFIGURE_SMTP_IMAP_LINK') }}
      </router-link>
      {{ $t('INBOX_MGMT.ADD.EMAIL_CHANNEL.CONFIGURE_SMTP_IMAP_TEXT') }}
    </p>
  </div>
</template>
